import WorkspaceUtils from '../../utils/workspace-utils';
import { AvailableWorkspaces } from '@tecton/ComponentRedesign/SharedComponentTypes';
import { WorkspaceWithPermissions } from '../context/types';

export const getSideNavigationWorkspaces = (workspaces: WorkspaceWithPermissions[]): AvailableWorkspaces => {
  const recentWorkspaces: string[] = WorkspaceUtils.getRecentWorkspaces();
  return workspaces?.reduce(
    (availableWorkspaces: AvailableWorkspaces, workspace) => {
      workspace?.capabilities?.materializable
        ? availableWorkspaces?.live.push({
            name: workspace.name ?? '',
            workspaceType: 'Live',
            isAccessible: workspace.isAccessible,
          })
        : availableWorkspaces?.development.push({
            name: workspace.name ?? '',
            workspaceType: 'Development',
            isAccessible: workspace.isAccessible,
          });

      if (recentWorkspaces.includes(workspace?.name ?? '')) {
        availableWorkspaces?.recent.push({
          name: workspace.name ?? '',
          workspaceType: workspace?.capabilities?.materializable ? 'Live' : 'Development',
          isAccessible: workspace.isAccessible,
        });
      }

      return availableWorkspaces;
    },
    {
      recent: [],
      live: [],
      development: [],
    }
  );
};
